module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('v-data-table', {
    staticClass: "elevation-1",
    attrs: {
      "headers": _vm.headers,
      "id": "hello",
      "items": _vm.objTiers,
      "hide-actions": "",
      "disable-initial-sort": "",
      "rows-per-page-items": [20, 40, 60, 80, 100]
    },
    scopedSlots: _vm._u([{
      key: "items",
      fn: function(props) {
        return [_c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.minimum))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v(_vm._s(props.item.maximum))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [_vm._v("R" + _vm._s(props.item.total))]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [(props.item.id != 0) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncEditTier(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])]) : _vm._e(), (props.item.id == 0) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncUpdateBase(props.item)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("edit")])]) : _vm._e()]), _vm._v(" "), _c('td', {
          staticClass: "text-xs-right",
          attrs: {
            "width": "20%"
          }
        }, [(props.item.id != 0) ? _c('a', {
          on: {
            "click": function($event) {
              $event.preventDefault();
              return _vm.fncDeleteTier(props.item.id)
            }
          }
        }, [_c('i', {
          staticClass: "material-icons"
        }, [_vm._v("delete_forever")])]) : _vm._e()])]
      }
    }])
  })], 1)
},staticRenderFns: []}